/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOrderingProfileCatalogFiltersRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetOrderingProfileCatalogFiltersResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getOrderingProfileCatalogFilters = (request: GetOrderingProfileCatalogFiltersRequest, options?: CashRequestOptions) => post<GetOrderingProfileCatalogFiltersRequest, GetOrderingProfileCatalogFiltersResponse>("/2.0/cash/get-ordering-profile-catalog-filters", request, {...options, rejectOnError: true })